import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import { useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";

const OrderActions = ({ rowData, userRole }) => {
  const navigate = useNavigate();

  return (
    <span className="flex flex-row justify-center">
      {(userRole.id === 1 || userRole.id === 4) && (
        <Tooltip title="مشاهده سرویس‌های سفارش" arrow={true} placement="bottom">
          <IconButton
            sx={{ mx: "0.25rem" }}
            onClick={() =>
              navigate("/orders/services", {
                state: rowData,
              })
            }
          >
            <HomeRepairServiceIcon className="text-green-600" />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="تغییر وضعیت سفارش" arrow={true} placement="bottom">
        <IconButton
          sx={{ mx: "0.25rem" }}
          onClick={() =>
            navigate("/orders/order-status", {
              state: rowData,
            })
          }
        >
          <EditIcon className="text-yellow-400" />
        </IconButton>
      </Tooltip>
      <Tooltip title="مشاهده پیام‌های تیکت" arrow={true} placement="bottom">
        <IconButton
          sx={{ mx: "0.25rem" }}
          onClick={() =>
            navigate("/orders/ticket", {
              state: rowData,
            })
          }
        >
          <QuestionAnswerIcon className="text-green-500" />
        </IconButton>
      </Tooltip>
      <Tooltip title="قسط بندی" arrow={true} placement="bottom">
        <IconButton
          sx={{ mx: "0.25rem" }}
          onClick={() =>
            navigate("/orders/installments", {
              state: rowData,
            })
          }
        >
          <ChecklistRtlIcon className="text-blue-600" />
        </IconButton>
      </Tooltip>
    </span>
  );
};

export default OrderActions;
